// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1DxrRAojT8GVtJUcc0FQMT ._3zK2pnmOPIaarPcpQGDYIH{margin-right:10px}._1DxrRAojT8GVtJUcc0FQMT ._2-DHmRzd6oCPgcYaZi4VHY{margin-left:10px}\n", ""]);
// Exports
exports.locals = {
	"petstore": "_1DxrRAojT8GVtJUcc0FQMT",
	"previous": "_3zK2pnmOPIaarPcpQGDYIH",
	"next": "_2-DHmRzd6oCPgcYaZi4VHY"
};
module.exports = exports;
